import { createContext, useContext, type ReactNode } from "react";
import type { PaidMediaOverviewAttributionMode } from "src/services/PaidMediaOverviewAPI";

export type OverviewAttributionSource = "platform" | "shopify";

const AttributionContext = createContext<OverviewAttributionSource>("platform");

export function toOverviewAttributionSource(
  mode: PaidMediaOverviewAttributionMode | null | undefined
): OverviewAttributionSource {
  return mode === "shopify_validated" ? "shopify" : "platform";
}

export function toPaidMediaAttributionMode(
  source: OverviewAttributionSource
): PaidMediaOverviewAttributionMode {
  return source === "shopify" ? "shopify_validated" : "platform_reported";
}

export function OverviewAttributionProvider({
  value,
  children,
}: {
  value: OverviewAttributionSource;
  children: ReactNode;
}) {
  return <AttributionContext.Provider value={value}>{children}</AttributionContext.Provider>;
}

export function useOverviewAttribution(): OverviewAttributionSource {
  return useContext(AttributionContext);
}
